export const COURSE_BOOKING_DETAILS = 'COURSE_BOOKING_DETAILS'